export const StatementHeader = (props) => {
    return (
        <header className="header has-yellow-bg">
            <h3 className="header__name text-black">
                {props.step} Statement
            </h3>
        </header>
    )
}